<template>
	<div id="wrapper">
		<SidebarView
			:memacc="true"
			:memaccVisible="true"
			:commissionPay="true"
		/>
		<div class="d-flex flex-column" id="content-wrapper">
			<div id="content">
				<TopbarView />
				<div class="mx-3">
					<div class="card card-shape home-box">
						<div class="card-header">
							<h6 class="m-0 fw-bold text-green">Pay Commission (Excel)</h6>
						</div>
						<div class="card-body">
							<p class="small text-muted mb-3">
								<strong>Payment execution</strong> — uploads Excel and runs deductions against members and GL.
								This is separate from <strong>Commission deduction setup</strong> (rules only).
							</p>
							<commission-imports :pay-only="true" />
						</div>
					</div>
				</div>
			</div>
			<footer></footer>
		</div>
		<ChatBot />
		<a class="d-inline scroll-to-top" href="#page-top"><i class="fas fa-angle-up"></i></a>
	</div>
</template>

<script>
import SidebarView from "@/views/main/components/Sidebar.vue";
import TopbarView from "@/views/main/components/Topbar.vue";
import CommissionImports from "../imports/CommissionImports.vue";
import ChatBot from "@/views/components/AI/ChatBot.vue";

export default {
	name: "CommissionPay",
	components: {
		SidebarView,
		TopbarView,
		CommissionImports,
		ChatBot,
	},
};
</script>
